export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/speechwriting.d154a85.svg";